import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ScheduleList from '@components/Schedules/ScheduleList';

const useStyles = makeStyles((theme) => ({
  bacnetSchedulePanel: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  scheduleContent: {
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
  },
}));

const BacnetSchedulePanel = ({ bacnetUnit, onClose, isDesktop = true, onBacnetSchedulesUpdate }) => {
  const classes = useStyles();

  if (!bacnetUnit) {
    return null;
  }

  return (
    <div className={classes.bacnetSchedulePanel}>
      <div className={classes.scheduleContent}>
        <ScheduleList
          mode="bacnet"
          bacnetUnit={bacnetUnit}
          hideSchedulesPanel={onClose}
          isDesktop={isDesktop}
          onBacnetSchedulesUpdate={onBacnetSchedulesUpdate}
        />
      </div>
    </div>
  );
};

export default BacnetSchedulePanel;
